import type { SVGProps } from "react";
import { cn } from "@/lib/utils";

/**
 * Cerebellum mark — geometric "C" built from three concentric arc-ridges
 * (a nod to cerebellar folia) threaded with node endpoints.
 *
 * Use `tight` at ≤16px where the full ridge set would smudge.
 */
export function CerebellumMark({
  tight = false,
  className,
  ...props
}: { tight?: boolean } & SVGProps<SVGSVGElement>) {
  if (tight) {
    return (
      <svg
        viewBox="0 0 64 64"
        aria-label="Cerebellum"
        className={cn("inline-block", className)}
        {...props}
      >
        <path
          d="M 52 18 A 20 20 0 1 0 52 46"
          fill="none"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
        />
        <circle cx="52" cy="18" r="4" fill="currentColor" />
        <circle cx="52" cy="46" r="4" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg
      viewBox="0 0 64 64"
      aria-label="Cerebellum"
      className={cn("inline-block", className)}
      {...props}
    >
      <path
        d="M 54 16 A 22 22 0 1 0 54 48"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M 48 22 A 14 14 0 1 0 48 42"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.75"
      />
      <path
        d="M 42 27 A 7 7 0 1 0 42 37"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.5"
      />
      <circle cx="54" cy="16" r="3" fill="currentColor" />
      <circle cx="54" cy="48" r="3" fill="currentColor" />
      <circle cx="48" cy="22" r="2.2" fill="currentColor" />
      <circle cx="48" cy="42" r="2.2" fill="currentColor" />
    </svg>
  );
}
